/**
 * Footer Component
 * Footer with legal links (Impressum, Privacy Policy)
 */

import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface FooterProps {
  /** Additional class names */
  className?: string;
}

/**
 * Footer component with legal links
 */
export function Footer({ className }: FooterProps) {
  const { t } = useTranslation();

  return (
    <footer
      className={cn(
        'px-4 py-4',
        'md:px-8 md:py-6',
        'lg:px-12',
        className
      )}
    >
      <nav className="flex flex-row gap-4" aria-label={t('footer.legalNavigation')}>
        <Link
          to="/impressum"
          className="text-sm text-[var(--color-primary-start)] hover:underline w-fit"
        >
          {t('footer.impressum')}
        </Link>
        <Link
          to="/datenschutz"
          className="text-sm text-[var(--color-primary-start)] hover:underline w-fit"
        >
          {t('footer.privacyPolicy')}
        </Link>
        <Link
          to="/agb"
          className="text-sm text-[var(--color-primary-start)] hover:underline w-fit"
        >
          {t('footer.agb')}
        </Link>
      </nav>
    </footer>
  );
}
